import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=057f9d0e"
import script from "./CouponManagement.vue?vue&type=script&lang=js"
export * from "./CouponManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports